import {i18n} from "@/config/i18n";
import L251120 from "@/views/blog/blog-content/251120/251120";

export default {
    name: 'BlogList',
    data() {
        return {
            searchQuery: '',
            selectedCategory: 'all',
            displayLimit: 10,
            loadMoreIncrement: 10,
            blogSources: [
                {
                    id: 1,
                    title: i18n.global.t("blog.recruitmentTitle"),
                    description: i18n.global.t("blog.recruitmentDes"),
                    author: i18n.global.t("representName"),
                    publishDate: '15/06/2025',
                    category: i18n.global.t("blog.intern"),
                    image: "https://songhancapital.com/assets/image/banner_3.png",
                    routeName: 'Intership',
                    color: 'from-blue-500 to-cyan-500',
                    tags: [i18n.global.t("blog.internship"), i18n.global.t("blog.technology"), i18n.global.t("blog.recruitment")],
                    views: '12.3k',
                    likes: '10.4k',
                    isNew: false
                },
                {
                    id: 2,
                    title: i18n.global.t("blog.marginIntroTitle"),
                    description: i18n.global.t("blog.marginIntroDes"),
                    author: i18n.global.t("common.TVSISupport"),
                    publishDate: '05/04/2025',
                    category: i18n.global.t("blog.financialProducts"),
                    image: "https://songhancapital.com/assets/image/banner_4.png",
                    routeName: 'MarginSummer2025',
                    color: 'from-green-500 to-teal-500',
                    tags: ['SH 6.8', i18n.global.t("blog.marginEndow"), i18n.global.t("blog.interestRate"), i18n.global.t("blog.finance"), i18n.global.t("blog.transaction")],
                    views: '13.7k',
                    likes: '12.4k',
                    isNew: false
                },
                {
                    id: 3,
                    title: i18n.global.t("blog.donate50Title"),
                    description: i18n.global.t("blog.donate50Des"),
                    author: i18n.global.t("common.SHCTrading"),
                    publishDate: '22/07/2025',
                    category: i18n.global.t("blog.promotion"),
                    image: "https://songhancapital.com/assets/image/banner_1.png",
                    routeName: 'NewAccountVantage',
                    color: 'from-purple-500 to-indigo-500',
                    tags: ['Vantage', i18n.global.t("blog.promotion50"), i18n.global.t("blog.newAccount"), i18n.global.t("blog.EAtrading"), i18n.global.t("blog.endow"), 'SHC'],
                    views: '12.2k',
                    likes: '11.6k',
                    isNew: false
                },
                {
                    id: 4,
                    title: i18n.global.t("blog.safeInvestmentTitle"),
                    description: i18n.global.t("blog.safeInvestmentDes"),
                    author: i18n.global.t("common.SHCTrading"),
                    publishDate: '30/07/2025',
                    category: i18n.global.t("blog.EAtradingAndInvest"),
                    image: "https://songhancapital.com/assets/image/banner_2.png",
                    routeName: 'EaShc',
                    color: 'from-green-500 to-emerald-500',
                    tags: ['EA SHC', i18n.global.t("blog.EAAuto"), i18n.global.t("blog.profit10"), i18n.global.t("blog.safeInvestment"), i18n.global.t("about.copy"), 'Vantage', 'SHcapital'],
                    views: '15.8k',
                    likes: '12.9k',
                    isNew: false,
                },
                {
                    id: 5,
                    title: i18n.global.t("blog.connectStudentTitle"),
                    description: i18n.global.t("blog.connectStudentDes"),
                    author: i18n.global.t("blog.departmentSI"),
                    publishDate: '26/08/2025',
                    category: i18n.global.t("blog.eventConnect"),
                    image: "https://songhancapital.com/assets/image/banner5.jpg",
                    routeName: 'ConectStudent',
                    color: 'from-orange-500 to-red-500',
                    tags: [i18n.global.t("blog.discussion"), i18n.global.t("blog.student"), i18n.global.t("blog.business"), i18n.global.t("blog.connect"), i18n.global.t("blog.job"), i18n.global.t("blog.statistical")],
                    views: '11.2k',
                    likes: '10.4k',
                    isNew: false
                },
                {
                    id: 6,
                    title: i18n.global.t("blog.article251120.heroTitle"),
                    description: i18n.global.t("blog.article251120.heroLead"),
                    author: i18n.global.t("representName"),
                    publishDate: '20/11/2025',
                    category: i18n.global.t("blog.eventConnect"),
                    image: "https://www.songhancapital.com/assets/image/banner_6mobile.jpg",
                    routeName: 'L251120',
                    color: 'from-indigo-500 to-purple-500',
                    tags: [ i18n.global.t("blog.article251120.badge") ],
                    views: '13.1k',
                    likes: '12.2k',
                    isNew: false
                },
                {
                    id: 7,
                    title: i18n.global.t("blog.promo100k.heroTitle"),
                    description: i18n.global.t("blog.promo100k.heroLead"),
                    author: i18n.global.t("representName"),
                    publishDate: '26/11/2025',
                    category: i18n.global.t("blog.eventConnect"),
                    image: "https://www.songhancapital.com/assets/image/banner_7mobile.jpg",
                    routeName: 'Promo100k',
                    color: 'from-indigo-500 to-purple-500',
                    tags: [ i18n.global.t("blog.promo100k.badge") ],
                    views: '17.1k',
                    likes: '16.2k',
                    isNew: false
                },
                {
                    id: 8,
                    title: i18n.global.t("blog.top8Vantage.cardTitle"),
                    description: i18n.global.t("blog.top8Vantage.cardDesc"),
                    author: i18n.global.t("common.SHCTrading"),
                    publishDate: '19/03/2026',
                    category: i18n.global.t("blog.financialProducts"),
                    bannerClass: 'top8-hero-card',
                    bannerLabel: 'Top 8 Vantage',
                    bannerIcon: 'fas fa-trophy',
                    routeName: 'Top8Vantage',
                    color: 'from-yellow-500 to-amber-500',
                    tags: ['Vantage', 'Top 8', 'EA', 'SHC', 'Copy trading'],
                    views: '25.1k',
                    likes: '19.5k',
                    isNew: false
                },
                {
                    id: 9,
                    title: 'Vietnam Premier Reward – PU Prime 2026',
                    description: i18n.global.t("blog.puPrime.cardDesc"),
                    author: 'SHC Capital',
                    publishDate: '01/05/2026',
                    category: i18n.global.t("blog.promotion"),
                    bannerClass: 'pu-prime-hero-card',
                    bannerLabel: 'Vietnam Premier Reward',
                    bannerIcon: 'fas fa-gift',
                    bannerSub: '01/05/2026 – 31/07/2026',
                    routeName: 'PuPrimeVietnamReward',
                    color: 'from-red-500 to-orange-500',
                    tags: ['PU Prime', 'Vietnam Premier Reward', 'BMW', 'Rolex', 'CFD'],
                    views: '13.4k',
                    likes: '7.2k',
                    isNew: false
                },
                {
                    id: 10,
                    title: i18n.global.t("blog.vantagebonus.cardTitle"),
                    description: i18n.global.t("blog.vantagebonus.cardDesc"),
                    author: 'Vantage x SHC Capital',
                    publishDate: '04/05/2026',
                    category: i18n.global.t("blog.promotion"),
                    bannerClass: 'vantage-bonus-card',
                    bannerLabel: '0.88% Daily Bonus',
                    bannerIcon: 'fas fa-percentage',
                    bannerSub: '04/05/2026 – 03/11/2026',
                    routeName: 'VantageBonus088',
                    color: 'from-purple-600 to-violet-600',
                    tags: ['Vantage', '0.88% Bonus', 'Daily Profit', '$888', 'CFD'],
                    views: '10.2k',
                    likes: '5.2k',
                    isNew: false
                },
                {
                    id: 12,
                    title: i18n.global.t("blog.masterpartner.cardTitle"),
                    description: i18n.global.t("blog.masterpartner.cardDesc"),
                    author: 'Sông Hàn Capital',
                    publishDate: '05/07/2026',
                    category: i18n.global.t("blog.promotion"),
                    bannerClass: 'master-partner-card',
                    bannerLabel: 'Master Partner Program',
                    bannerIcon: 'fas fa-handshake',
                    bannerSub: 'Min. Capital $100,000 USD',
                    routeName: 'MasterPartnerProgram',
                    color: 'from-amber-600 to-yellow-500',
                    tags: ['Master Partner', 'EA Trading', 'Revenue Share', 'Spread Rebates', 'MT5'],
                    views: '16.5k',
                    likes: '13.2k',
                    isNew: true
                },
                {
                    id: 11,
                    title: i18n.global.t("blog.shcEdu.cardTitle"),
                    description: i18n.global.t("blog.shcEdu.cardDesc"),
                    author: 'SHC Capital',
                    publishDate: '10/12/2025',
                    category: i18n.global.t("blog.eventConnect"),
                    bannerClass: 'shc-edu-neon-card',
                    bannerLabel: 'SHC Education Lab',
                    bannerIcon: 'fas fa-brain',
                    bannerSub: 'Technical Analysis · Student Edition',
                    routeName: 'ShcTechnicalAnalysis',
                    color: 'from-indigo-600 to-cyan-500',
                    tags: ['SHC Capital', 'Technical Analysis', 'MA', 'Investment', 'Students'],
                    views: '12.8k',
                    likes: '6.9k',
                    isNew: false
                }
            ]
        }
    },
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    },
    computed: {
        categories() {
            return [...new Set(this.blogSources.map(blog => blog.category))]
        },
        sortedBlogs() {
            const parseDate = (dateStr) => {
                const [day, month, year] = dateStr.split('/');
                return new Date(`${year}-${month}-${day}`);
            };

            return [...this.filteredBlogs].sort((a, b) => {
                return parseDate(b.publishDate) - parseDate(a.publishDate);
            });
        },
        filteredBlogs() {
            let filtered = this.blogSources

            if (this.selectedCategory !== 'all') {
                filtered = filtered.filter(blog => blog.category === this.selectedCategory)
            }

            if (this.searchQuery.trim()) {
                const query = this.searchQuery.toLowerCase().trim()
                filtered = filtered.filter(blog =>
                    blog.title.toLowerCase().includes(query) ||
                    blog.description.toLowerCase().includes(query) ||
                    blog.author.toLowerCase().includes(query) ||
                    blog.tags.some(tag => tag.toLowerCase().includes(query))
                )
            }

            return filtered
        },
        displayedBlogs() {
            return this.sortedBlogs.slice(0, this.displayLimit);
        },

        hasMoreBlogs() {
            return this.displayLimit < this.sortedBlogs.length;
        }
    },
    methods: {
        navigateTo(blog) {
            if (blog.routeName) {
                this.$router.push({
                    name: blog.routeName
                });
            } else {
                alert(i18n.global.t("blog.discussion"));
            }
        },
        loadMoreBlogs() {
            this.displayLimit += this.loadMoreIncrement;
        },
        resetDisplayLimit() {
            this.displayLimit = 10;
        }
    },
    watch: {
        selectedCategory() {
            this.resetDisplayLimit();
        },
        searchQuery() {
            this.resetDisplayLimit();
        }
    }
}
